import React from "react";
import { Toolbar } from "material-ui/Toolbar";

export default class CustomToolbar extends React.PureComponent {
    render() {
        const { style = {} } = this.props;
        return <Toolbar {...this.props} style={style} />;
    }
}
